var _rect, _text, _circle, _circle2, _circle3, _text2, _rect2, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _rect6, _circle4, _text7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentResponsibleAiGovernanceModelMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 640,
    viewBox: "0 0 360 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Responsible AI governance model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 638,
    rx: 27,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 40,
    fill: "#74BDFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "GOVERNANCE MODEL"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 215,
    r: 119,
    fill: "#07162B",
    stroke: "#2B5A85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 215,
    r: 88,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 215,
    r: 61,
    fill: "#0B2340",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 202,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "HUMAN-OWNED"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 19
  }, "DECISION"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 361,
    width: 148,
    height: 92,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 391,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "AUDITABLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 22
  }, "Evidence and history"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 361,
    width: 148,
    height: 92,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 391,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 206,
    dy: 0
  }, "REVIEWABLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 206,
    dy: 22
  }, "Human intervention"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 469,
    width: 148,
    height: 92,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#30D6A1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 499,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "CONTROLLED"), /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 22
  }, "Access and privacy"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 469,
    width: 148,
    height: 92,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#F4B63D"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 499,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 206,
    dy: 0
  }, "MONITORED"), /*#__PURE__*/React.createElement("tspan", {
    x: 206,
    dy: 22
  }, "Quality and drift"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 582,
    width: 312,
    height: 34,
    rx: 11,
    fill: "#10243E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 599,
    r: 5,
    fill: "#30D6A1"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 603,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800
  }, "AI SUPPORTS \xB7 PEOPLE REMAIN ACCOUNTABLE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentResponsibleAiGovernanceModelMobile);
export default __webpack_public_path__ + "static/media/custom-development-responsible-ai-governance-model-mobile.3db10616646e05b16ce8cc1f598a989f.svg";
export { ForwardRef as ReactComponent };